var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DBE4F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#159B3F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,20 L0,20 L0,0 L28,0 L28,6.66666667 L0,20 L28,13.3333333 L28,20 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#0858B4",
    mask: "url(#mask-2)",
    points: "0 0 9.33333333 0 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#ED3535",
    mask: "url(#mask-2)",
    points: "18.6666667 0 28 0 28 6.66666667 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#08964F",
    mask: "url(#mask-2)",
    points: "28 20 28 13.3333333 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-253",
    fill: "#FFDD67",
    mask: "url(#mask-2)",
    points: "9.33333333 0 18.6666667 0 0 20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/SC.7c88b613a86f9519ed2c1b2f58ff43a5.svg";
export { ForwardRef as ReactComponent };